import styled from 'styled-components';

// Mesma anatomia da tela Construir Petição: cabeçalho centralizado, filtro
// por tribunal no meio e o campo de busca no rodapé (barra do chat)
export const Area = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 28px 40px 16px;
`;

// Resultados: busca no topo, alinhada à esquerda com a lista
export const Topo = styled.div`
  margin: 0 0 18px;

  > div {
    max-width: none;
    padding: 0;
  }
`;

// Tela inicial: cabeçalho e busca centralizados verticalmente
export const Centro = styled.div`
  min-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-bottom: 6vh;
`;

export const Cabecalho = styled.div`
  text-align: center;
  margin-bottom: 8px;

  h2 {
    font-size: 30px;
    font-weight: 800;
    margin-bottom: 6px;
    color: #21354a;
  }

  p {
    font-size: 14.5px;
    font-weight: 700;
    color: #3d4a44;
    margin-bottom: 18px;
  }
`;

export const FiltroLinha = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0 0 8px;
  font-size: 14px;
  color: #6b7585;

  button {
    border: 1px solid #21354a;
    border-radius: 999px;
    background: #fff;
    color: #21354a;
    font-size: 13.5px;
    font-weight: 700;
    padding: 6px 14px;
    cursor: pointer;

    &.ativo {
      background: #21354a;
      color: #fff;
    }
  }
`;

// Painel do checklist, aberto acima da barra de busca
export const Tribunais = styled.div`
  max-height: 45vh;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #d6dcd8;
  border-radius: 10px;
  padding: 14px 18px;
  margin-bottom: 8px;
`;

export const Acoes = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
  font-size: 14px;
  color: #6b7585;

  button {
    border: none;
    background: none;
    padding: 0;
    font-size: 14px;
    font-weight: 700;
    color: #057757;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const Colunas = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 6px 24px;

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  li {
    padding: 8px 0;
  }

  label {
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 0;
    font-size: 14.5px;
    color: #1a2035;
    cursor: pointer;

    input {
      width: 18px;
      height: 18px;
      accent-color: #007bff;
      cursor: pointer;
    }

    small {
      color: #8a94a6;
      font-size: 12.5px;
    }
  }

  .subitens {
    padding-left: 28px;
    margin-top: 4px;

    li {
      padding: 6px 0;
    }
  }

  .link {
    margin: 4px 0 0 28px;
    border: none;
    background: none;
    padding: 0;
    font-size: 13px;
    font-weight: 700;
    color: #21354a;
    text-decoration: underline;
    cursor: pointer;
  }
`;

// Categoria (Jurisprudência / Dica Legal / Súmula / Legislação) dentro da barra
export const Categoria = styled.select`
  height: 40px;
  border: 1px solid #d6dcd8;
  border-radius: 8px;
  background: #fff;
  font-size: 13.5px;
  color: #21354a;
  padding: 0 8px;
`;

// Lista de resultados própria do Dr. Licita (substitui o ListAcervo antigo)
export const Lista = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const Card = styled.button`
  width: 100%;
  text-align: left;
  font: inherit;
  background: #fff;
  border: 1px solid #d6dcd8;
  border-radius: 10px;
  padding: 14px 18px;
  cursor: pointer;

  header {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 8px;
    font-size: 13px;
    color: #6b7585;

    strong {
      font-size: 13.5px;
      color: #21354a;
    }

    em {
      font-style: normal;
      font-weight: 700;
      font-size: 11.5px;
      color: #21354a;
      background: #ccddeb;
      border-radius: 4px;
      padding: 2px 7px;
    }
  }

  p {
    margin: 0;
    font-size: 14.5px;
    line-height: 1.55;
    color: #1a2035;

    mark {
      background: #fff1b8;
      color: inherit;
      border-radius: 3px;
      padding: 0 2px;
    }
  }

  footer {
    display: flex;
    flex-wrap: wrap;
    gap: 14px;
    margin-top: 8px;
    font-size: 12.5px;
    color: #6b7585;
  }

  &:hover {
    border-color: #366793;
    box-shadow: 0 2px 10px rgba(33, 53, 74, 0.08);
  }
`;

export const Vazio = styled.div`
  padding: 24px 0;
  font-size: 14.5px;
  color: #6b7585;
`;

export const Paginacao = styled.div`
  margin: 18px 0 8px;
`;

// Detalhe do conteúdo (jurisprudência, dica legal, súmula) no shell do Dr. Licita
export const Detalhe = styled.div`
  max-width: 1000px;
  margin: 0 auto;

  .voltar {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    border: none;
    background: none;
    padding: 0;
    margin-bottom: 18px;
    font-size: 14.5px;
    font-weight: 700;
    color: #21354a;
    cursor: pointer;

    i {
      font-size: 18px;
    }

    &:hover {
      text-decoration: underline;
    }
  }

  article {
    background: #fff;
    border: 1px solid #d6dcd8;
    border-radius: 10px;
    padding: 26px 30px;
  }

  header h3 {
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 0 0 10px;
    font-size: 22px;
    font-weight: 800;
    color: #21354a;

    em {
      font-style: normal;
      font-size: 12px;
      font-weight: 700;
      background: #ccddeb;
      border-radius: 4px;
      padding: 3px 8px;
    }
  }

  .chips {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-bottom: 16px;

    span {
      font-size: 12.5px;
      color: #21354a;
      background: #eef3f7;
      border-radius: 999px;
      padding: 4px 10px;
    }
  }

  dl {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 10px 20px;
    margin: 0 0 18px;

    dt {
      font-size: 12px;
      text-transform: uppercase;
      letter-spacing: 0.4px;
      color: #6b7585;
    }

    dd {
      margin: 0;
      font-size: 14.5px;
      color: #1a2035;
    }

    a {
      color: #007bff;
    }
  }

  .video iframe {
    width: 100%;
    aspect-ratio: 16 / 9;
    border: 0;
    border-radius: 8px;
    margin-bottom: 16px;
  }

  .indexadores {
    font-size: 14px;
    color: #3d4a44;
    margin-bottom: 16px;
  }

  section {
    margin-top: 22px;

    h4 {
      margin: 0 0 8px;
      font-size: 15px;
      font-weight: 800;
      color: #21354a;
    }

    > div,
    > p {
      font-size: 14.5px;
      line-height: 1.65;
      color: #1a2035;
      text-align: justify;
    }

    .pre {
      white-space: pre-wrap;
    }
  }

  .citar {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    margin-top: 10px;
    border: 1px solid #366793;
    border-radius: 6px;
    background: #fff;
    color: #21354a;
    font-size: 13px;
    font-weight: 700;
    padding: 6px 12px;
    cursor: pointer;

    i {
      font-size: 16px;
    }

    &:hover {
      background: #eef3f7;
    }
  }

  .abas {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-bottom: 12px;

    button {
      border: 1px solid #d6dcd8;
      border-radius: 999px;
      background: #fff;
      color: #21354a;
      font-size: 13px;
      padding: 5px 12px;
      cursor: pointer;

      &.ativa {
        background: #21354a;
        border-color: #21354a;
        color: #fff;
      }
    }
  }

  .relacionados {
    list-style: none;
    margin: 0;
    padding: 0;

    li {
      border-top: 1px solid #e2e7ea;
    }

    button {
      width: 100%;
      text-align: left;
      border: none;
      background: none;
      padding: 10px 0;
      cursor: pointer;

      span {
        display: block;
        font-size: 14px;
        line-height: 1.5;
        color: #1a2035;
      }

      small {
        font-size: 12.5px;
        color: #6b7585;
      }

      &:hover span {
        color: #007bff;
      }
    }
  }
`;
